import { useEffect, useState } from "react";

const YouTubeVideo = ({ videoUrl = "", videoClass = "" }) => {
  const [videoId, setVideoId] = useState(null);

  useEffect(() => {
    if (!videoUrl || typeof videoUrl !== "string") return;

    try {
      const url = new URL(videoUrl);
      const hostname = url.hostname;

      let id = null;
      if (hostname.includes("youtube.com")) {
        id = url.searchParams.get("v");
      } else if (hostname === "youtu.be") {
        id = url.pathname.slice(1);
      }

      if (id && id.length === 11) {
        setVideoId(id);
      } else {
        console.error("Failed to extract video ID from URL:", videoUrl);
      }
    } catch (err) {
      console.error("Invalid YouTube URL:", videoUrl);
    }
  }, [videoUrl]);

  if (!videoId) return null; // or return a fallback/error UI

  return (
    <iframe
      className={`w-full h-[600px] ${videoClass}`}
      src={`https://www.youtube.com/embed/${videoId}?rel=0`}
      title="YouTube Video"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};

export default YouTubeVideo;
